/**
 * XION Medical product data — Documentation systems
 * Content sourced from xion-medical.com (split from completeProductsData.js).
 */

export const documentationSystems = {
  id: 'documentation-recording-systems',
  name: 'Documentation & Recording Systems',
  slug: 'documentation-recording-systems',
  category: 'Documentation',
  description: 'Professional image and video documentation solutions for endoscopic procedures. XION documentation systems integrate seamlessly with camera processors and provide comprehensive archiving capabilities.',
  overview: 'The MATRIX DS data station with DiVAS software enables complete patient data management, image capture, video recording, and seamless integration with hospital information systems via DICOM/HL7 interfaces.',
  products: [
    {
      id: 'matrix-ds-data-station',
      name: 'MATRIX DS Data Station',
      slug: 'matrix-ds-data-station',
      tagline: 'Complete documentation and data management',
      description: 'Professional data station for image capture, video recording, patient data management, and HIS/PACS integration. Includes DiVAS software for comprehensive workflow management.',
      features: [
        'High-quality image capture',
        'Video recording in various formats',
        'Patient data management',
        'DICOM/HL7 connectivity',
        'Integration with HIS/PACS',
        'Customizable report generation',
        'Secure data archiving',
        'Multi-monitor support'
      ],
      specifications: {
        software: 'DiVAS 2.8',
        features: ['Image Capture', 'Video Recording', 'DICOM', 'HL7'],
        connectivity: 'DICOM, HL7, GDT'
      },
      images: ['/products/transparent/matrix-ds6-web.png']
    },
    {
      id: 'panel-pc-documentation',
      name: 'Panel PC Documentation System',
      slug: 'panel-pc-documentation',
      tagline: 'Integrated all-in-one documentation',
      description: 'Compact Panel PC with integrated monitor and DiVAS software. Perfect for space-constrained environments requiring full documentation capabilities.',
      features: [
        'All-in-one design',
        'Touch screen interface',
        'DiVAS software included',
        'Image and video capture',
        'Patient database',
        'Network connectivity',
        'Space-saving solution'
      ],
      specifications: {
        display: '21.5" Full HD',
        software: 'DiVAS 2.8',
        features: ['Touch Screen', 'All-in-One', 'Network Ready']
      },
      images: ['/products/transparent/panelpc-web.png']
    }
  ]
};
